import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Select from "react-select";
import Notification from "./components/Notification.jsx";
import {
  Event,
  AccessTime,
  ErrorOutline,
  LocationOn,
} from "@material-ui/icons";

import {
  setUserLocation,
  addUserData,
  setOrderScreen,
  setFormattedAddress,
  setNotificationData,
  setUserData,
  resetSelectedDelivery,
  resetSelectedPickup,
  resetAvailableDeliveryDate,
  resetAvailablePickupDate,
  setSubmitting,
} from "../../redux/actions";

import translation from "../../translations/FirstOrderScreen";
import headerTranslation from "../../translations/OrderBlockHeader";
import NumpadNumber from "../../components/numpad/Number";
import Api from "../../utils/api/Api";
import { userCreateGuestSession } from "../../utils/helpers";
import { Button } from "../../components/refectored/Button";
import { formatDst } from "../../mixin/date";
import WindowSelector from "./components/WindowsSelector/WindowSelector";
import moment from "moment-timezone";

const FirstOrderScreen = (props) => {
  const { notification } = props;
  // const
  return (
    <main className="order-block-body order-block-body-grid">
      {notification.status && <Notification />}
      <CheckLocationInputs {...props} />
    </main>
  );
};

const ShowServicePoint = ({ point }) => {
  return (
    <div className="service-point-card">
      <div className="service-point-icon">
        <LocationOn />
      </div>
      <div className="service-point-content">
        <div className="service-point-company">{point.company}</div>
        <div className="service-point-address">{point.addressLine}</div>
      </div>
    </div>
  );
};

const ShowError = ({ error }) => {
  const lang = localStorage.getItem("lang");

  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-icon">
          <ErrorOutline />
        </div>
        <div className="error-message">
          <h3 className="error-title">{translation.error[lang] || "Fout"}</h3>
          <p className="error-text">{error}</p>
        </div>
      </div>
    </div>
  );
};

const ShowOrder = ({ order, packsQty }) => {
  const lang = localStorage.getItem("lang");

  return (
    <div className="order-summary-container">
      <div className="order-summary-header">
        <h3 className="order-summary-title">
          {translation.orderDetails[lang]}
        </h3>
        <div className="order-status-badge">
          <span className="status-dot"></span>
          {translation.confirmed[lang]}
        </div>
      </div>

      <div className="order-details-grid">
        <div className="service-point-info order-pickup-info">
          <div className="pickup-details">
            <div className="pickup-date-section">
              <div className="block-title">
                <Event className="block-icon" />
                {translation.pickupDate[lang]}
              </div>
              <div className="pickup-date">
                {formatDst(order.pickupTime, "dddd DD MMMM")}
              </div>
            </div>

            <div className="pickup-time-section">
              <div className="block-title">
                <AccessTime className="block-icon" />
                {translation.pickupTime[lang]}
              </div>
              <div className="time-range">
                <span className="time-label">{translation.between[lang]}</span>
                <span className="time-value">{`${formatDst(
                  order.frames.pickup.from,
                  "HH:mm"
                )} - ${formatDst(order.frames.pickup.to, "HH:mm")}`}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className="contact-info-simple"
          dangerouslySetInnerHTML={{ __html: translation.orderContact[lang] }}
        />
        {packsQty ? (
          <div className="bags-qty-info" style={{ marginTop: '12px' }}>
            <strong>Aantal zakken:</strong> {packsQty}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const CheckLocationInputs = ({
  resetSelectedPickup,
  resetAvailablePickupDate,
  resetAvailableDeliveryDate,
  resetSelectedDelivery,
  setSubmitting,
}) => {
  const lang = localStorage.getItem("lang");
  const [services, setServices] = useState([]);
  const [state, setState] = useState({
    showNumpad: true,
    servicePoint: null,
    code: null,
    error: null,
    variation: 1,
    loading: false,
    order: null,
    submitting: false,
    pickupModal: false,
    deliveryModal: false,
    services: [],
    packsQty: 1,
    packsQtyError: null,
  });

  const debounceTimerRef = useRef(null);
  const requestIdRef = useRef(0);

  const onChange = (value) => {
    updateState({ code: value });
  };

  const loadServicePoint = (value, requestId) => {
    resetSelectedPickup();
    resetAvailablePickupDate();
    resetAvailableDeliveryDate();
    resetSelectedDelivery();

    updateState({ loading: true });

    Api.fetchServicePointB2b(value)
      .then(({ data }) => {
        // Only update state if this is the latest request
        if (requestId === requestIdRef.current) {
          updateState({
            servicePoint: data,
            showNumpad: false,
            error: null,
            code: value,
            loading: false,
          });
        }
      })
      .catch(async () => {
        // Only update state if this is the latest request
        if (requestId === requestIdRef.current) {
          updateState({
            servicePoint: null,
            showNumpad: false,
            error: translation.locationNotFound[lang],
            code: value,
            loading: false,
          });
        }
      });
  };

  const loadServices = () => {
    Api.getServices().then(({ data }) => {
      const servicesArr = data.data.map((item) => ({
        value: item.type,
        label: item.name,
      }));
      setServices(servicesArr);
    });
  };

  const clear = (e) => {
    e.preventDefault();

    // Clear any pending debounce timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    updateState({
      showNumpad: true,
      servicePoint: null,
      error: null,
      code: null,
      variation: state.variation + 1,
      loading: false,
      submitting: false,
      order: null,
      pickupDate: null,
      pickupTime: null,
      deliveryDate: null,
      deliveryTime: null,
    });
  };

  const updateState = (newState) => {
    const oldState = { ...state };

    setState({ ...oldState, ...newState });
  };

  useEffect(() => {
    // Clear previous timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // Only trigger API call if code has at least 4 characters
    if (state.code && state.code.length >= 4) {
      // Increment request ID for the new request
      requestIdRef.current += 1;
      const currentRequestId = requestIdRef.current;

      // Debounce the API call by 500ms
      debounceTimerRef.current = setTimeout(() => {
        updateState({ showNumpad: false });
        loadServicePoint(state.code, currentRequestId);
        loadServices();
      }, 500);
    } else {
      // Reset state if code is too short
      updateState({
        servicePoint: null,
        error: null,
        loading: false,
      });
    }

    // Cleanup timer on unmount
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [state.code]);

  const encodeDates = (date, time) =>
    moment.tz(`${date}T${time}:00`, "Europe/Amsterdam").format();

  const placeOrder = async () => {
    updateState({ submitting: true });
    setSubmitting(true);

    await userCreateGuestSession();

    Api.placeNoTerminalManualOrder(
      state.code,
      encodeDates(state.pickupDate, state.pickupTime),
      encodeDates(state.deliveryDate, state.deliveryTime),
      state.services,
      state.packsQty
    )
      .then(({ data }) => {
        setSubmitting(false);
        updateState({
          showNumpad: false,
          error: null,
          order: data,
          submitting: false,
        });
      })
      .catch(async (err) => {
        setSubmitting(false);
        console.log(err);
        updateState({
          servicePoint: null,
          showNumpad: false,
          error: translation.orderPlacingError[lang],
          submitting: false,
        });
      });
  };

  const onPickupSelected = (date, time) => {
    updateState({
      pickupDate: date,
      pickupTime: time,
    });
  };

  const onDeliverySelected = (date, time) => {
    updateState({
      deliveryDate: date,
      deliveryTime: time,
    });
  };

  const changeService = (options) => {
    updateState({
      services: options.map((item) => item.value),
    });
  };

  const onPacksQtyChange = (e) => {
    const raw = e.target.value
    // allow empty while typing
    if (raw === '') {
      updateState({
        packsQty: '',
        packsQtyError: 'Voer een getal groter dan 0 in',
      })
      return
    }
    const val = parseInt(raw, 10)
    if (!Number.isNaN(val) && val > 0) {
      updateState({ packsQty: val, packsQtyError: null })
    } else {
      updateState({
        packsQty: raw,
        packsQtyError: 'Voer een getal groter dan 0 in',
      })
    }
  }

  return (
    <form
      key={state.variation}
      className="first-screen-inputs"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className="card-header">
        <div className="welcome-text">
          <h1>
            {state.order
              ? translation.orderPlaced[lang]
              : headerTranslation.titleB2b[lang]}
          </h1>
        </div>
      </div>

      <div className="card-top-section">
        <div className="input-block">
          <h2>
            {state.order
              ? translation.orderPlaced[lang]
              : translation.fillLocationCode[lang]}
          </h2>
          <div className="input-wrapper">
            <NumpadNumber
              id="location-code-input"
              onChange={onChange}
              label=""
              placeholder={"7430"}
              decimal={false}
              negative={false}
              position="top"
              sync={true}
              inline={true}
              show={state.showNumpad && !state.loading}
              // loading={state.loading}
              leadingZeros={true}
            />
          </div>
        </div>

        <div className="image-block">
          <img
            src={
              require("../../images/figma-design/business-image-609bed.png")
                .default
            }
            alt="Dobbi Service"
          />
        </div>
      </div>

      <div
        className="card-bottom-section"
        style={
          state.showNumpad
            ? { paddingBottom: "200px" }
            : { paddingBottom: "50px" }
        }
      >
        <div className="main-block">
          {state.servicePoint && !state.loading && (
            <div className="service-point-wrapper-mobile">
              <ShowServicePoint point={state.servicePoint} />
            </div>
          )}

          {!state.order && !state.error && !state.loading && state.code && (
            <div className="service-point-wrapper">
              <h2>{translation.servicesSelect[lang]}</h2>
              {state.servicePoint && (
                <div className="service-select-wrapper">
                  <Select
                    isMulti
                    options={services}
                    isSearchable={false}
                    onChange={changeService}
                    placeholder="Select..."
                    className="modern-select"
                    classNamePrefix="modern-select"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "60px",
                        border: "2px solid rgba(109, 179, 149, 0.15)",
                        borderRadius: "12px",
                        boxShadow:
                          "0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06)",
                        background:
                          "linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)",
                        backdropFilter: "blur(10px)",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        "&:hover": {
                          borderColor: "rgba(109, 179, 149, 0.4)",
                          boxShadow:
                            "0 4px 16px rgba(109, 179, 149, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08)",
                          transform: "translateY(-1px)",
                        },
                      }),
                      controlFocused: (provided, state) => ({
                        ...provided,
                        borderColor: "#6DB395",
                        boxShadow:
                          "0 0 0 4px rgba(109, 179, 149, 0.15), 0 4px 16px rgba(109, 179, 149, 0.12)",
                        transform: "translateY(-2px)",
                      }),
                      valueContainer: (provided) => ({
                        ...provided,
                        padding: "8px 16px",
                        gap: "8px",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "rgba(109, 179, 149, 0.1)",
                        borderRadius: "8px",
                        border: "1px solid rgba(109, 179, 149, 0.2)",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: "#1a202c",
                        fontSize: "14px",
                        fontWeight: "500",
                        fontFamily:
                          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      }),
                      multiValueRemove: (provided) => ({
                        ...provided,
                        color: "#6b7280",
                        "&:hover": {
                          backgroundColor: "rgba(239, 68, 68, 0.1)",
                          color: "#dc2626",
                        },
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: "#9ca3af",
                        fontSize: "15px",
                        fontFamily:
                          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                        fontWeight: "500",
                      }),
                      input: (provided) => ({
                        ...provided,
                        color: "#1a202c",
                        fontSize: "15px",
                        fontFamily:
                          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      }),
                      indicatorSeparator: () => ({
                        display: "none",
                      }),
                      dropdownIndicator: (provided, state) => ({
                        ...provided,
                        color: "#6b7280",
                        padding: "8px",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        transform: state.selectProps.menuIsOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                        "&:hover": {
                          color: "#6DB395",
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        backgroundColor: "rgba(255, 255, 255, 0.95)",
                        backdropFilter: "blur(20px)",
                        border: "1px solid rgba(109, 179, 149, 0.2)",
                        borderRadius: "12px",
                        boxShadow:
                          "0 20px 40px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.06)",
                        marginTop: "8px",
                        overflow: "hidden",
                      }),
                      menuList: (provided) => ({
                        ...provided,
                        padding: "8px 0",
                        maxHeight: "200px",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? "linear-gradient(135deg, rgba(109, 179, 149, 0.08) 0%, rgba(109, 179, 149, 0.04) 100%)"
                          : "transparent",
                        color: state.isFocused ? "#6DB395" : "#374151",
                        fontSize: "15px",
                        fontFamily:
                          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                        fontWeight: "500",
                        padding: "12px 20px",
                        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                        borderLeft: state.isFocused
                          ? "3px solid #6DB395"
                          : "3px solid transparent",
                        "&:active": {
                          backgroundColor:
                            "linear-gradient(135deg, rgba(109, 179, 149, 0.12) 0%, rgba(109, 179, 149, 0.06) 100%)",
                        },
                      }),
                    }}
                  />
                </div>
              )}
              <div className="bags-qty-block" style={{ marginTop: '16px' }}>
                <h2>Aantal zakken</h2>
                <div className="bags-qty-input-wrapper">
                  <input
                    id="bags-qty-input"
                    type="number"
                    min="1"
                    step="1"
                    value={state.packsQty}
                    onChange={onPacksQtyChange}
                    className="bags-qty-input"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    style={{
                      width: '140px',
                      height: '60px',
                      border: '2px solid rgba(109, 179, 149, 0.15)',
                      borderRadius: '12px',
                      padding: '0 16px',
                      fontSize: '18px',
                    }}
                  />
                  {state.packsQtyError && (
                    <div
                      className="error-text"
                      style={{ color: '#dc2626', marginTop: '8px' }}
                    >
                      {state.packsQtyError}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {!state.order && state.servicePoint && !state.loading && (
            <div className="window-selector-block">
              {!state.error && (
                <WindowSelector
                  code={state.code}
                  onPickupSelected={onPickupSelected}
                  onDeliverySelected={onDeliverySelected}
                />
              )}
            </div>
          )}

          {state.error && !state.loading && <ShowError error={state.error} />}

          {state.order && (
            <ShowOrder order={state.order} packsQty={state.packsQty} />
          )}
          {state.code && !state.loading && !state.order && (
            <div className="service-point-info service-point-actions">
              <div className="actions-inline-container">
                <Button
                  color="green"
                  onClick={() => placeOrder()}
                  submitting={state.submitting ? 1 : 0}
                  className="checked"
                  isDisabled={
                    !(
                      !state.order &&
                      state.pickupDate &&
                      state.pickupTime &&
                      state.deliveryTime &&
                      state.deliveryDate &&
                      !state.error &&
                      state.packsQty &&
                      !state.packsQtyError
                    )
                  }
                >
                  {translation.placeOrder[lang]}
                </Button>
              </div>
            </div>
          )}

          {!state.showNumpad && !state.loading && !state.submitting && (
            <div className="clear-link-wrapper">
              <a href="#" className="clear-link" onClick={clear}>
                {state.code && !state.order
                  ? translation.orEnterNewCode[lang]
                  : translation.enterNewCode[lang]}
              </a>
            </div>
          )}
        </div>
        <div className="contact-block">
          {state.servicePoint && !state.loading && (
            <div className="service-point-wrapper-desktop">
              <ShowServicePoint point={state.servicePoint} />
            </div>
          )}

          <p
            className="contact-caption"
            dangerouslySetInnerHTML={{
              __html: translation.bannerText(
                ' of bel ons op <a href="tel:+31850187540">+31 (0)85 018 7540</a>'
              )[lang],
            }}
          />
        </div>
      </div>
    </form>
  );
};

const mapStateToProps = ({
  webView,
  userLocation,
  userData,
  notification,
}) => ({
  wv: webView,
  userLocation,
  userData,
  notification,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setOrderScreen: (data) => dispatch(setOrderScreen(data)),
    setFormattedAddress: (data) => dispatch(setFormattedAddress(data)),
    setUserLocation: (data) => dispatch(setUserLocation(data)),
    addUserData: (data) => dispatch(addUserData(data)),
    setNotificationData: (data) => dispatch(setNotificationData(data)),
    setUserData: (data) => dispatch(setUserData(data)),
    resetSelectedDelivery: (data) => dispatch(resetSelectedDelivery(data)),
    resetSelectedPickup: (data) => dispatch(resetSelectedPickup(data)),
    resetAvailableDeliveryDate: (data) =>
      dispatch(resetAvailableDeliveryDate(data)),
    resetAvailablePickupDate: (data) =>
      dispatch(resetAvailablePickupDate(data)),
    setSubmitting: (data) => dispatch(setSubmitting(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(FirstOrderScreen);
